[
  {
    "code": "JO-AJ",
    "name": "Ajlun"
  },
  {
    "code": "JO-AQ",
    "name": "Al 'Aqaba"
  },
  {
    "code": "JO-BA",
    "name": "Al Balqa'"
  },
  {
    "code": "JO-KA",
    "name": "Al Karak"
  },
  {
    "code": "JO-MA",
    "name": "Al Mafraq"
  },
  {
    "code": "JO-AM",
    "name": "Amman"
  },
  {
    "code": "JO-AT",
    "name": "At Tafilah"
  },
  {
    "code": "JO-AZ",
    "name": "Az Zarqa'"
  },
  {
    "code": "JO-IR",
    "name": "Irbid"
  },
  {
    "code": "JO-JA",
    "name": "Jarash"
  },
  {
    "code": "JO-MD",
    "name": "Madabah"
  },
  {
    "code": "JO-MN",
    "name": "Ma‘an"
  }
]